import {omneticApi as api} from '@dms/api/base';

import {
  ChangeBusinessCaseLeadQualityApiArg,
  ChangeBusinessCaseLeadQualityApiArgSchema,
  ChangeBusinessCaseLeadQualityApiResponse,
  ChangeBusinessCaseLeadQualityApiResponseSchema,
  ChangeInterestLeadQualityApiArg,
  ChangeInterestLeadQualityApiArgSchema,
  ChangeInterestLeadQualityApiResponse,
  ChangeInterestLeadQualityApiResponseSchema,
  GetLeadQualityOptionsApiResponse,
  GetLeadQualityOptionsApiResponseSchema,
} from './types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    changeBusinessCaseLeadQuality: build.mutation<
      ChangeBusinessCaseLeadQualityApiResponse,
      ChangeBusinessCaseLeadQualityApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/${queryArg.businessCaseId}/change-lead-quality`,
        method: 'POST',
        body: queryArg.changeLeadQualityRequestBody,
      }),
      extraOptions: {
        requestSchema: ChangeBusinessCaseLeadQualityApiArgSchema,
        responseSchema: ChangeBusinessCaseLeadQualityApiResponseSchema,
      },
      invalidatesTags: () => [
        'Interest',
        'InterestActivity',
        'BusinessCaseActivity',
        'BusinessCaseDetail',
      ],
    }),
    changeInterestLeadQuality: build.mutation<
      ChangeInterestLeadQualityApiResponse,
      ChangeInterestLeadQualityApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/interest/${queryArg.interestId}/change-lead-quality`,
        method: 'POST',
        body: queryArg.changeLeadQualityRequestBody,
      }),
      extraOptions: {
        requestSchema: ChangeInterestLeadQualityApiArgSchema,
        responseSchema: ChangeInterestLeadQualityApiResponseSchema,
      },
      invalidatesTags: () => [
        'Interest',
        'InterestActivity',
        'BusinessCaseActivity',
        'BusinessCaseDetail',
      ],
    }),
    getLeadQualityOptions: build.query<GetLeadQualityOptionsApiResponse, void>({
      query: () => ({
        url: `/dms/v1/lead/quality-options`,
      }),
      extraOptions: {
        responseSchema: GetLeadQualityOptionsApiResponseSchema,
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useChangeBusinessCaseLeadQualityMutation,
  useChangeInterestLeadQualityMutation,
  useGetLeadQualityOptionsQuery,
} = injectedRtkApi;
